import { writable } from "svelte/store";
export const username = writable('');
export const players = writable({});
export const waitingFor = writable([]);
export const gifSubmitted = writable(false);
export const submissions = writable([]);
export const votingResults = writable([]);
export const stats = writable({});
export const backendVersion = writable("");
export const chatMessages = writable([]);
export const leader = writable(false);
export const topics = writable([]);
export const preferences = writable({
    AutoSkip: true,
    MaxPlayers: -1,
    MinPlayers: -1,
    MaxTopics: -1,
    MinTopics: -1,
    ShuffleTopics: true,
    Permissions: 0,
});
export const round = writable({
    topic: '',
    currentRound: 0,
    totalRounds: 0
});
export const ws = writable();
export const state = writable(0);
